import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

type MutationInput = {
  reportId: string;
  clientId?: string;
  familyId?: string;
};

export function useDeleteDataExport() {
  const queryClient = useQueryClient();

  const {
    mutateAsync,
    error,
    isPending: isLoading,
    reset,
  } = useMutation<unknown, Error, MutationInput>({
    mutationFn: ({ clientId, familyId, reportId }: MutationInput) =>
      api.delete(
        familyId
          ? `families/${familyId}/data-exports/${reportId}`
          : `clients/${clientId}/data-exports/${reportId}`,
      ),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['clients'] });
    },
  });

  const deleteDataExport = async (clientId: string, reportId: string) => {
    return mutateAsync({ clientId, reportId });
  };

  const deleteFamilyDataExport = async (familyId: string, reportId: string) => {
    return mutateAsync({ familyId, reportId });
  };

  return {
    deleteDataExport,
    deleteFamilyDataExport,
    error,
    isLoading,
    reset,
  };
}
